import { useMapContext } from '../contexts/mapContext';
import { useEffect } from 'react';

export default function useSizeProperty({ endpointQuery }: { endpointQuery: any }) {
	const { setSelectedFeatureProperty } = useMapContext()[1];

	useEffect(() => {
		const property = endpointQuery?.options?.parameters?.metadataPropertyNames?.[0];
		setSelectedFeatureProperty(property);
	}, [endpointQuery, setSelectedFeatureProperty]);
}
